//import * as Vue from 'vue' //vue 3
//import { createApp, configureCompat }  from 'vue';

import { createApp, configureCompat, toRaw } from 'vue';
import _ from 'lodash'

export var Settings = {
	PopupUseIframe: true,
	PopupMaximize: false,
	GridColumnMenu: {},
	// false .. zobrazuje se primo filtr
	// true .. submenus - razení,slouce, filtr 
	// šířka, při které se změní chování menu = bootstrap lg
	layoutMenuModeWidth: 1024
}

var notificationObject = null;
// type = 
// info .. light blue
// success green
// warning orange 
// error   red
export function Notification(text, type) {

	if (notificationObject == null) {
		notificationObject = $("<span />").kendoNotification(
			{
				autoHideAfter: 20000,
				position:
				{
					pinned: true,
					top: 20,
					left: null,
					bottom: null,
					right: 20
				}
			}
		).data("kendoNotification");
	}
	//notificationObject.show({ message: text }, type);
	notificationObject.show(text, type);
	return true;
}



// nastaví focus na první položku s atributem autofocus . nutno v popup 
export function setFocusInitial() {
	var contr = $("[autofocus]");
	if (contr.length > 0) contr[0].focus();
}

// wait
// immediate  true .. spustí se poprvé
export function debounce(func, wait, immediate) {
	var timeout;
	return function () {
		var context = this, args = arguments;
		// funkce po vyprsení timer 
		var later = function () {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};


export function GetKendoObject(childElement, kendoType) {
	var element = childElement;
	{
		while (element.parentElement) {
			element = element.parentElement;
			var x = ($(element).data(kendoType));
			if (x) {
				return x;
			}
		}
	}
	return null;
}

//export function Confirm(text,title) {
//	return kendo.confirm(text);
//}

export function Confirm(text, title) {
	var promise = $.Deferred();
	var dialog = $("<div/> ").kendoDialog({
		title: title,
		content: text,
		actions: [
			{
				text: "OK",
				action: function (e) {
					promise.resolve()
				},
				primary: true
			},
			{
				text: "Cancel",
				action: function (e) {
					promise.reject()
				}
			}
		]
	}).data("kendoDialog");

	dialog.open()
	return promise;
}

export function CrossroadsDialog(text, title, ways) {
	console.log(ways);
	var promise = $.Deferred();

	let items = ways.map(function (way) {
		return {
			text: way.text,
			action: function (e) {
				promise.resolve(way.url)
			},
			primary: true
		}
	})

	var dialog = $("<div/> ").kendoDialog({
		title: title,
		content: text,
		actions: items
	}).data("kendoDialog");

	dialog.open()
	return promise;
}

export function Info(text, title) {
	var promise = $.Deferred();
	var dialog = $("<div/> ").kendoDialog({
		title: title,
		content: text,
		actions: [{
			text: "OK",
			action: function (e) {
				promise.resolve()
			},
			primary: true
		}]
	}).data("kendoDialog");

	dialog.open()
	return promise;
}


//pro ikony v  Kendo grid 
export function OnClickDelete(item, eventx) {
	if (eventx) {
		event = eventx;
	};
	var title = ' '
	if (item.title) {
		title = item.title;
	};
	var grid = GetKendoObject(item, "kendoGrid");
	var row = $(event.srcElement).closest("tr");
	grid.select(row);

	var href = event.target.href || event.target.parentElement.href || event.target.parentElement.parentElement.href;
	DefinityLib.Confirm("Opravdu smazat záznam ?", title)
		.then(function (e) {
			return DefinityLib.AjaxGetJson(href);
		})
		.then(function (e) {
			if (e.Success) {
				DefinityLib.Notification("Záznam smazán", "success");
				grid.dataSource.read();
			}
			else {
				DefinityLib.Info(e.Message, "error");
			}
		})
		.fail(OnAjaxError);
	return false;
}

//pro ikony v KendoGrid 
export function OnClickDetailTryEvent(item, eventx) {
	OnClickDetail(item, eventx, true);
	return false;
}
export function OnClickDetail(item, eventx, TryEvent = false) {
	var defTitle = "Detail";
	if (eventx) {
		event = eventx;
	};
	var title = '';
	if (item.title) {
		title = item.title;
	};
	var grid = GetKendoObject(item, "kendoGrid");
	var row = $(event.srcElement).closest("tr");
	if (grid) grid.select(row);
	var href = event.target.href || event.target.parentElement.href || event.target.parentElement.parentElement.href;
	var promise;
	if (TryEvent) {
		promise = DefinityLib.PopupUrlTryEvent(href, title)

	}
	else {
		promise = DefinityLib.PopupUrl(href, title)
	}
	promise.then(
		(result1) => {
			if (result1.cancel) {
			} else {
				grid.dataSource.read()
			}
		}
	);
	return false;
}

export function GridSetColumns(GridSettingsName, grid) {

	var options = localStorage[GridSettingsName];
	if (options) {
		var OptionsParsed = JSON.parse(options);
		var shiftBack = 0;
		OptionsParsed.columns.forEach(
			function (optionsColumn, optionsIndex) {
				var gridColumn = grid.columns.find(function (column) { return column.field == optionsColumn.field; })
				if (gridColumn) {
					grid.reorderColumn(optionsIndex - shiftBack, gridColumn);
					grid.resizeColumn(gridColumn, optionsColumn.width);
					if (optionsColumn.hidden && !gridColumn.hidden) {
						grid.hideColumn(gridColumn)
					}
					else if (!optionsColumn.hidden && gridColumn.hidden) {
						grid.showColumn(gridColumn)
					}
				}
				else {
					shiftBack++;
				}
				// resizeColumn
				// showColumn

			}
		)
		return;
	}
}
export function GridSelectedDataItems(grid) {
	var selectedRows = grid.select();
	var selectedDataItems = [];
	for (var i = 0; i < selectedRows.length; i++) {
		var dataItem = grid.dataItem(selectedRows[i]);
		selectedDataItems.push(dataItem);
	}
	return selectedDataItems;
}
export function GridSelectedDataItem(grid) {

	var selectedDataItems = GridSelectedDataItems(grid);
	if (selectedDataItems.length > 0) {
		return selectedDataItems[0]
	}
	return null;
}



export function NewVue(options) {
	var element = options.el; // element or css selector
	if (!element) {
		alert("Error: NewVue has no element, no proxy will be created")
	}
	options.el = undefined;
	if (typeof options.data === 'function') {
	} else if (typeof options.data === 'undefined') {
	} else {
		var data = { ...options.data };
		options.data = function () { return data };
	}

	// mounted
	if (typeof options.methods.OnMounted === 'function') {
		if (typeof options.mounted === 'function') {
			options.methods.mountedOrig = options.mounted;
			options.mounted = function () {
				options.methods.mountedOrig();
				options.methods.OnMounted(this);  // e param in forms is vueFormProxy 
			}
		}
		else {
			options.mounted = options.methods.OnMounted()
		}
	}

	options.compilerOptions =
	{
		//compatConfig:
		//{
		//	MODE: 2,
		//	whitespace:'preserve'
		//}
	}

	const app = createApp(options);
	app.config.errorHandler = (err) => {
		Info(err.stack, err.message);
	}
	app.mount(element); // 
	return app;
	// reference zvenku : app._instance.proxy
}
export function NewVueProxy(options) {
	var x = NewVue(options);
	return x._instance.proxy;
}
export function VueToRaw(obj) {
	return toRaw(obj);
}

export function mecGlobal() {
	return mecGlobal;
}

//table
export function kendoBaseTable(options) {
	options.extends = baseTable;
	return options;
}
// event pripojen pres vue
// title,onclose nepovinne
export function PopUpEvent(event, title, OnClose) {
	event.preventDefault();
	var href = event.currentTarget.href || event.currentTarget.parentElement.href || event.currentTarget.parentElement.parentElement.href;
	var promise = PopupUrl(href, title, OnClose);
	return promise;
}
// event pripojen pres <element onclick="return OnClickA(this);"
// title,onclose nepovinne
export function PopUpElement(element, title, OnClose, Modal) {
	var href = element.href || element.parentElement.href || element.parentElement.parentElement.href;
	PopupUrl(href, title, OnClose, Modal);
	return false; // zabrani pokracovani
}
export function PopUpElementTryEvent(element, title, OnClose, Modal) {
	var href = element.href || element.parentElement.href || element.parentElement.parentElement.href;
	PopupUrlTryEvent(href, title, OnClose, Modal);
	return false; // zabrani pokracovani
}
export function PopupUrlTryEvent(href, title, OnClose, Modal) {

	var detailObject = { href: href, title: title, OnClose: OnClose, Modal: Modal, handled: false, promise: null }
	const event = new CustomEvent("PopupUrlExecute", { detail: detailObject });
	window.dispatchEvent(event);
	if (!detailObject.handled) {
		return DefinityLib.PopupUrl(href, title, OnClose, Modal);
	}
	return detailObject.promise;
}

// přidáva se do hlavního okna 
// iframe.load(function (e) {PopupUrlsOnWindow(iframe[0].contentWindow)});
export function PopupUrlsOnWindow(window) {
	window.removeEventListener("PopupUrlExecute", PopupUrlExecuteHandle);// aby se nespustilo duplicitně
	window.addEventListener("PopupUrlExecute", PopupUrlExecuteHandle);
}

export function PopupUrlExecuteHandle(e) {
	e.detail.handled = true;
	e.detail.promise = DefinityLib.PopupUrl(e.detail.href, e.detail.title, e.detail.OnClose, e.detail.Modal);
}


//=== Hlavní popup procedura ===
// vrací promise
export function PopupUrl(href, title, OnClose, Modal) {
	if (Modal == undefined) Modal = true;
	var promise = $.Deferred();
	href = urlAddNomenu(href)
	//iframe
	var windowOptions = {
		...WindowModalOptions(href, title, Modal),
		...{
			close: function (e) {
				// zavreni krizkem
				let result =
				{
					cancel: e.userTriggered,
					submitResult: window.DefinityData, // informace o uložení
					//selectedItem:
				};
				console.log("CloseWindowEvent");
				console.log(result);
				popup.destroy();
				promise.resolve(result); // okno jednou zavru
			}
		}
	};
	// OnAccept
	var popup = $('<div class="window" />').kendoWindow(windowOptions).data("kendoWindow");
	//custom toolbar link action
	popup.wrapper.find("[aria-label='link']").click(
		function (e) {  //k-i-GetUrl
			Info(href, "Window url")
			e.preventDefault();
		}
	);

	if (Settings.PopupMaximize) {
		popup.center().maximize();
	}
	popup.open();

	var jqueryHelp = popup.wrapper.find("[aria-label='question-circle']")
	jqueryHelp.each(function () { this.hidden = true; }) // skrytí

	var comunication =
	{
		// Poskytne funkci DefinityOnInit pro nastavení titulku a nápovědy pro child window
		DefinityOnInit: function (title, helpUrl) {
			if (helpUrl) {
				jqueryHelp.each(function () { this.hidden = false; })
				jqueryHelp.click(
					function (e) {
						DefinityLib.PopupUrl(helpUrl, title = 'Help (' + popup.title() + ')', true);
						e.preventDefault();
					}
				);
			}
			if (title) {
				popup.title(title)
			}
		},

		DefinityOnAccept: function (e) {
			//mozna uzivatelská akce, lépe vyuzij promise
			if (typeof OnClose === "function") {
				OnClose(e);
			}
			let result =
			{
				popup: popup,
				cancel: false,
				submitResult: e// window.DefinityData, // informace o uložení
			};
			console.log("DefinityOnAccept.CloseWindow");
			console.log(result);
			popup.destroy();// zavre okno 
			promise.resolve(result);
		},
		DefinityKendoPopup: popup
	}
	var initPopupClient = function (iframeWindowObject) {
		try {
			iframeWindowObject.DefinityOnAccept = comunication.DefinityOnAccept;
			iframeWindowObject.DefinityOnInit = comunication.DefinityOnInit;
			iframeWindowObject.DefinityKendoPopup = comunication.DefinityKendoPopup;
			iframeWindowObject.Definity = comunication;
		}
		catch (error) {
			console.warn("Cross-origin popup frame: skipping callback attach", error);
		}
	}
	var iframeWindowObject;
	if (Settings.PopupUseIframe) {
		var iframe = popup.element.children("iframe")[0];
		initPopupClient(iframe.contentWindow)
		// refresh odstraní, ale DefinityOnInit můžem potřebova dřív  než je dokončen load
		iframe.addEventListener(
			'load',
			(e) => {
				initPopupClient(iframe.contentWindow)
			}
		);
	}
	else {
		initPopupClient(popup)
	}
	return promise;
}

export function GetPopup() {
	if (Settings.PopupUseIframe && window.Definity) return Definity.DefinityKendoPopup;
	else return null;
}





export function NavigateToEvent(event) { // _GridColumns
	event.preventDefault();
	var href = event.currentTarget.href || event.currentTarget.parentElement.href || event.currentTarget.parentElement.parentElement.href;
	var target = event.currentTarget.target || event.currentTarget.parentElement.target || event.currentTarget.parentElement.parentElement.target;
	return NavigateToUrl(href, target);
}

export function NavigateToElement(element) {
	var href = element.href || element.parentElement.href || element.parentElement.parentElement.href;
	var target = element.target || element.parentElement.target || element.parentElement.parentElement.target;
	return NavigateToUrl(href, target);
}

export function NavigateToUrl(href, target) {
	//_blank,_self,_parent,_top,framename
	//--https://www.w3schools.com/jsref/met_win_open.asp
	if (!target) {
		target = 'blank';
	}
	return window.open(href, target);
}









// zavre popup a vrati aktualni radek KendoGrid 
export function KendoSelectGridItem(gridId) {
	var xgrid = $("#" + gridId).data("kendoGrid");
	var selectedItem = xgrid.dataItem(xgrid.select());
	if (window.Bridge) window.Bridge.onSelectGridItem(gridId,selectedItem);

	if (typeof window.DefinityOnAccept === "function") {
		window.DefinityOnAccept(selectedItem);
	}
	return;
}
//-- Lze zavolat pro dialog, v OnLoad 
export function KendoDialogInit(title, helpUrl) {
	//-- pokud 
	if (window.Bridge) window.Bridge.onDialogInit(title, helpUrl);
	if (typeof window.DefinityOnInit === "function") {
		window.DefinityOnInit(title, helpUrl);
	}
	else {
		HelpInit(helpUrl)
	}
}

export function HelpInit(helpUrl) {
	var jqueryHelp = $("#help");
	jqueryHelp.each(
		function (index, element) {
			element.setAttribute("href", helpUrl);
		}
	);
}


export function SubmitDone(response, sender) {
	// standartně ZAVŘENÍ OKNA 
	// pozadavek doběhl. Presto může obsahovat chyby
	//je li spusteno v okně, spusti akce volající strany
	//  aktualizace zaznamu , viz OnClose

	//-- Info po ukoncení
	if (!DefinityLib.SubmitCheckResult(response, sender)) {
		event.preventDefault(); //prevent popup closing
		return;
	}

	if (window.Bridge) window.Bridge.onSubmitDone(response, sender);
	//-- Akce po ukoncení
	if (typeof window.DefinityOnAccept === "function") {
		window.DefinityData = response.data;   // předání výsledku
		window.DefinityOnAccept(response.data);// obsahuje zavrení okna
	}
	// je li responseUrl, přejde tam 
	if (response.request) {
		if (response.request.responseURL) {
			window.location = response.request.responseURL
		}
	}
}


export function SubmitDone_NoAction(response, sender) {
	// pozadavek doběhl. Presto může obsahovat chyby
	//-- Info po ukoncení
	if (!DefinityLib.SubmitCheckResult(response, sender)) {
		event.preventDefault(); //prevent popup closing
		return;
	}
	event.preventDefault(); //prevent popup closing
}


// true , pokud je pozadavek považován za úspěšný
export function SubmitCheckResult(response, sender) {
	// pozadavek doběhl. Presto může obsahovat chyby
	// je li spusteno v okně, spusti akce volající strany
	// standartně zavření okna
	//  aktualizace zaznamu , viz OnClose

	//-- Info po ukoncení
	if (response.success != undefined) {
		if (response.success) {
			console.log("submitedOK");
			sender.modelData = response.data;
			DefinityLib.Notification(response.message, 'success');
		}
		else {
			console.log("submitedWithError");
			sender.modelData = response.data;
			DefinityLib.Info(response.message, "Data nebyla uložena!!");
			return false;
		}
	}
	return true;
}


export function AjaxError(jqXHR) {
	//console.log(error.response.status) // 401
	//console.log(jqXHR.response.data.error) //Please Authenticate or whatever returned from server
	var status = 200;
	var title = "Application Error"
	var message = "";
	if (jqXHR.responseJSON && (jqXHR.responseJSON.title || jqXHR.responseJSON.detail)) {

		if (jqXHR.responseJSON.detail) {
			message = message + jqXHR.responseJSON.detail;
		}
		if (jqXHR.responseJSON.errors) {
			message = message + JSON.stringify(jqXHR.responseJSON.errors).replaceAll('{', '').replaceAll('}', '').replaceAll("\"", '');
		}
		status = jqXHR.status;

		if (jqXHR.responseJSON.title) {
			title = jqXHR.responseJSON.title;
		}
		else {
			title = GetErrorTitle(status);
		}
	}
	else if (jqXHR.status == undefined) {
		if (jqXHR.response != undefined) {
			//axios
			status = jqXHR.response.status;
			message = jqXHR.message;
			title = GetErrorTitle(status);
		}
	}
	else if (jqXHR.responseText) {
		//ajax responseText
		status = jqXHR.status;
		message = jqXHR.responseText;// "rejected"

		//try {
		//	obj = JSON.parse(jqXHR.responseText);
		//} catch {
		//	//obj = {}; // or null, or whatever default you want
		//}



		title = GetErrorTitle(status);
	}
	else {
		//ajax
		status = jqXHR.status;
		message = jqXHR.state() + jqXHR.responseText;// "rejected"
		title = GetErrorTitle(status);
	}
	return { status: status, title: title, message: message };
}


export function GetErrorTitle(status) {
	var ajaxMessages = AppMessages.ajaxMessages()
	switch (status) {
		case 400: // Nevalidní data, chybějící parametry, špatný formát.
			return `${ajaxMessages.BadRequest} (${status})`;
		case 401: //Unauthorized
			return `${ajaxMessages.LoginExpired} (${status})`;
		case 402:  // Validní JSON, ale obsahově špatné(např.email bez @).
			return `${ajaxMessages.Unprocessable}  (${status})`;
		case 403:  // Nedostatečná oprávnění
			return `${ajaxMessages.Forbidden} (${status})`;
		case 405:  // Metoda není povolena ??
			return `${ajaxMessages.MethodNotAllowed} (${status})`;

		case 500: // Internal Server Error - Chyba aplikace
			return `${ajaxMessages.InternalServerError} (${status})`;
		case 502: // Bad Gateway - API selhalo
			return `${ajaxMessages.BadGateway} (${status})`;
		case 503: // Service Unavailable
			return `${ajaxMessages.ServiceUnavailable} (${status})`
		default:
			return (`${ajaxMessages.UnknownError} (${status})`);
	}
}

export function OnAjaxError(jqXHR, useDialog = true) {
	// POZOR  _layoutOnLoadScripts
	var ajaxError = DefinityLib.AjaxError(jqXHR);




	if (ajaxError.status == 401)
	{   // not autorized
		if (window.Bridge) {
			window.Bridge.onAutentificationExpired(ajaxError);
		}
		else
		{
			PopupUrl('/Identity/Account/Login', localization?.loginExpired)
				.done(function (result) { });
		}
		return;
	}
	else if (jqXHR.status == 403) {
		// InsufficientPermissions
		e.preventDefault();
		if (jqXHR.responseText) {
			DefinityLib.Info(jqXHR.responseText, "Error");
		}
		else {
			DefinityLib.Info("InsufficientPermissions", "Error");
		}
		return;
	}
	else if (useDialog) {
		DefinityLib.Info(ajaxError.message, ajaxError.title);
	}
	else {
		Notification(ajaxError.message, 'error');
	}
}

export function SubmitFailed(error, sender) {
	//Pri chybe odeslani se spousti jak OnAjaxError, tak submit failed
	if (error.statusCode().status == 400) {
		if (error.response) {
			sender.modelState = error.response.data
		}
		else if (error.responseText) {
			try {
				var obj = JSON.parse(error.responseText);
				sender.modelState = obj;
			} catch {
				//obj = {}; // or null, or whatever default you want
			}
		}
	}
	if (window.Bridge) window.Bridge.onSubmitFailed(error);
	if (error) {
		DefinityLib.OnAjaxError(error, true);
	}
}


// modal window enabled
export function VueForm(element, options) {
	return VueOptionsMerge(
		options,
		{
			el: element,
			data: {
				modelState: {},
				flexBasisOriginal: { x: 'a' }
			},
			mounted() {
				console.log('Form Mounted')	
				// Apply the media query on initial load
				this.applyMediaQuery();
				// Apply the media query on window resize
				window.addEventListener("resize", this.applyMediaQuery);
			},
			methods:
			{
				applyMediaQuery: function () {
					//if (window.matchMedia("(min-width: 600px)").matches) {
					//	var that = this;
					//	var tagHelperLabels = $(this.$el).find(".input-group-prepend")
					//	tagHelperLabels.each(
					//		function (i, e) {
					//			var dataField = $(this).attr("data-field");
					//			var dataValue = that.flexBasisOriginal[dataField]
					//			if (dataValue)	$(this).css('flex-basis', dataValue);
					//		}
					//	);
					//} else {
					//	var that = this;
					//	var tagHelperLabels = $(this.$el).find(".input-group-prepend")
					//	tagHelperLabels.each(
					//		function (i, e) {
					//			var dataField = $(this).attr("data-field");
					//			var dataValue = that.flexBasisOriginal[dataField]
					//			if (!dataValue) that.flexBasisOriginal[dataField] = $(this).css('flex-basis');
					//			var dataFlexBSmall = $(this).attr("data-flexbsm");
					//			if (dataFlexBSmall) dataFlexBSmall = '95%';
					//			$(this).css('flex-basis', dataFlexBSmall);
					//		}
					//	)
					//}
				},
				setFocus: function (ref) {
					// $refs is an object that holds the DOM references to your inputs
					this.$refs[ref].focus();
				},
				submitCheckResult(response) {
					return DefinityLib.SubmitCheckResult(response, this);
				},
				submitDone(response) {
					return DefinityLib.SubmitDone(response, this);
				},
				submitFailed(error) {
					return DefinityLib.SubmitFailed(error, this);
				},
				submitForm(event) {
					var that = this;
					DefinityLib.AjaxPostFormData(event.target)
						.done(that.submitDone)
						.fail(that.submitFailed)
					event.preventDefault(); //prevents  submit by url after submit by proc
				},
			}
		}
	)
}


export function VueFormJson(element, options) {
	var x = VueOptionsMerge(
		options,
		VueForm(element,
			{
				methods: {
					submitForm(event) {  // and close if no error 
						DefinityLib.AjaxPostJson('event.target', this.modelData, false)
							.done(this.submitDone)
							.fail(this.submitFailed)
						event.preventDefault(); //prevents  submi by url
					}
				}
			}
		)
	)
	return x;
}

export function urlAddNomenu(href) {
	if (href.includes('?')) { href = href + "&NOMENU" }
	else { href = href + "?NOMENU" }
	return href
}
export function urlAdd(href, option) {
	if (href.includes('?')) { href = href + "&" + option }
	else { href = href + "?" + option }
	return href
}

export function WindowModalOptions(href, caption, modal) {
	if (modal == undefined) modal = true
	return {
		content: href,
		iframe: Settings.PopupUseIframe,
		//https://docs.telerik.com/kendo-ui/api/javascript/ui/window/configuration/actions
		actions: ["question-circle", "link", "Refresh", "Pin", "Minimize", "Maximize", "Close"], //question-circle=help,Custom=aktuální url,Close,Refresh,Minimize,Maximize,Pin
		draggable: true,
		resizable: true,
		autoFocus: false,
		themeColor: 'light',////  primary,dark,light,none
		//top: "20px",
		//size:'large',
		width: "80%",
		height: "80%",
		title: caption,
		modal: modal,
		close: function (e) {
			that.reload(item);
			popup.destroy();
		}
	};
}

export function VueOptionsMerge(options, def) {
	let result = { ...def, ...options };
	result.data = { ...def?.data, ...result?.data }
	result.methods = { ...def?.methods, ...result?.methods }
	return result
}

export function AjaxGetJson(url,async=true) {

	var result = $.ajax({
		async:async,
		type: "GET",
		headers: {
			'Content-Type': 'application/json', // vstup
			'Accept': 'application/json'		// vystup
		},
		url: url,
		cache: false,
		//dataType    : 'json',// datatype expected from server
		processData: false, // data budou prevedena na urlencoded
		contentType: false,
		global: false
	})
	//result.fail(OnAjaxError);
	return result;
}

export function AjaxPostJson(url, data,handleError=true) {
	var result = $.ajax({
		type: "POST",
		headers: {
			'Content-Type': 'application/json', // vstup
			'Accept': 'application/json'		// vystup
		},
		url: url,
		cache: false,
		//dataType    : 'json',// datatype expected from server
		processData: false, // data budou prevedena na urlencoded
		contentType: false,
		data: JSON.stringify(data),
		global: false
	});
	if (handleError) {
		result.fail(OnAjaxError);
	}
	return result;
}

export async function AjaxPostJsonAsync(url, data, handleError = true) {
	try {
		var result = await $.ajax({
			type: "POST",
			headers: {
				'Content-Type': 'application/json', // vstup
				'Accept': 'application/json'		// vystup
			},
			url: url,
			cache: false,
			//dataType    : 'json',// datatype expected from server
			processData: false, // data budou prevedena na urlencoded
			//contentType: false,
			data: JSON.stringify(data),
			global: false
		});
		return result;
	}
	catch (error) {
		debugger;
		if (handleError) {
			error.fail(OnAjaxError);
		}
		else {
			throw error;
		}
	}
	return result;
}

export function AjaxPostFormData(form, handleError = true) {
	var formdata = new FormData(form);
	var result= $.ajax({
		type: "POST",
		url: window.location,
		cache: false,
		processData: false,
		contentType: false,
		data: formdata,
		global:false
	})
	if (handleError) {
		result.fail(OnAjaxError);
	}
	return result;
}

export function ObjectToFormData(sourceObject) {
	var form_data = new FormData();
	for (var key in sourceObject) {
		form_data.append(key, sourceObject[key]);
	}
	return form_data;
}



//operator and , or
// condition string
export function JoinConditions(operator, conditions) {
	var xarray;
	//-- hodnota nebo pole=>pole
	if (Array.isArray(conditions)) xarray = conditions;
	else xarray = [conditions];
	//-- zrus prazdné polozky
	var x = [];
	xarray.forEach(
		(value) => {
			if (value != undefined && value != '') x.push(value);
		}
	);
	//--
	if (x.length > 1) return '(' + x.join(' ' + operator + ' ') + ')';
	else if (x.length > 0) return x.join(' ' + operator + ' ');
	else return '';
}

export function Condition(column, operator, value) {
	if (value == undefined || value == '')
		return '';
	else
		return column.concat(' ', operator, ' ', value);
}


export function getWindow(elementSelector) {
	if (_.isString(elementSelector)) {
		elementSelector = '[data-role="window"] ' + elementSelector;
	}
	var w = $(elementSelector).closest('[data-role="window"]');
	if (w.length === 0) {
		if (window.parent !== window.self) {
			try {
				var pw = $('.k-window-iframecontent[data-role="window"]', window.parent.document);
				var kw = window.parent.$.data(pw[0], "kendoWindow");
				if (kw) {
					return kw;
				}
			}
			catch (error) {
				console.warn("Cross-origin parent frame access blocked", error);
			}
		}
		return null;
	}
	return w.data("kendoWindow");
};

// pro context menu kendoGrid
export function gridGetContext(GridContext) {
	var current = {};
	current.grid = GridContext.grid;
	current.cell = GridContext.options.target[0]; // 
	current.colIdx = current.grid.cellIndex(current.cell);
	if (current.colIdx == -1) {
		//header
		current.colIdx = $(current.cell).attr('data-index');
		current.row = null;
		current.dataItem = null;
	}
	else {
		current.row = current.cell.parentElement;
		current.dataItem = current.grid.dataItem(current.row);
	}
	current.field = current.grid.columns[current.colIdx];
	return current;
}

export var GridFilterableUi = {
	DateTimePicker: function (element) {
		element.kendoDateTimePicker(); // initialize a Kendo UI DateTimePicker
	},
	DateTimeHtml: function (element) {
		var bind = element[0].dataset.bind;
		$(element).replaceWith("<input type='datetime-local' class='k-input k-input-md k-rounded-md k-input-solid' style='flex-flow: column' data-bind='" + bind + "'></input>"); // Replace the input element with an HTML textarea
	},
}